import { render, staticRenderFns } from "./editV5.vue?vue&type=template&id=05bc25b8"
import script from "./editV5.vue?vue&type=script&lang=js"
export * from "./editV5.vue?vue&type=script&lang=js"
import style0 from "./editV5.vue?vue&type=style&index=0&id=05bc25b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports